<template>
    <div>
        <el-dialog title='费用详情' :visible.sync='FeeDetaildiag' :close-on-click-modal='false'
                   :close-on-press-escape='false'
                   width='90%' v-dialogDrag @close='close' append-to-body>
            <FeeSplit :Splitdiag='Splitdiag' @closeSplitdiag='closeSplitdiag' :spilttableData='spilttableData'
                      @submitSplit='submitSplit'></FeeSplit>
            <updatevatdiag :updatevatdiag='updatevatdiag' @closeupdatevatdiag='closeupdatevatdiag'
                           :invoiceId='invoiceId'></updatevatdiag>
            <addvatdiag :addvatdiag='addvatdiag' @closeaddvatdiag='closeaddvatdiag'
                        :feeCollectionInfo='feeCollectionInfo'></addvatdiag>
            <div class='Centerupdown'>
                <el-button type='primary' @click='uploadFile' v-if="submitStatus == '0'">上传文件</el-button>
                <el-button type='primary' @click='forSplit' v-if="submitStatus == '0'">拆分批次</el-button>
            </div>
            <div class='box-item'>
                <div class='titledetail'>邮件基本信息</div>
                <div class='title-content Centerupdown'>
                    <span>邮件批次号:</span>
                    <span>{{ this.mailBatchNo }}</span>
                </div>
                <div class='title-content Centerupdown'>
                    <span>费用批次号:</span>
                    <span>{{ this.batchNo }}</span>
                </div>
            </div>
            <div class='box-item'>
                <div class='titledetail'>增值税发票明细表头字段</div>
                <taxtable :headData='vatheadData' ref='vatref' :tableData='vattableData'>
                    <template v-slot:no='scope'>
                        {{ scope.index + 1 }}
                    </template>
                    <template v-slot:inspectionStatus='scope'>
                        <div v-for='(item,index) in invoiceInspStatus' :key='index'
                             v-if='scope.taxval.inspectionStatus==item.value'>
                            {{ item.label }}
                        </div>
                    </template>
                    <template v-slot:taxRate='scope'>
                        <div v-for='(item,index) in taxRates' :key='index'
                             v-if='scope.taxval.taxRate==item.value'>
                            {{ item.label }}
                        </div>
                    </template>
                    <template v-slot:invoiceType='scope'>
                        <div v-for='(item,index) in invoiceTypes' :key='index'
                             v-if='scope.taxval.invoiceType==item.value'>
                            {{ item.label }}
                        </div>
                    </template>
                    <template v-slot:operate='scope'>
                        <div class='Centerupdown'>
                            <el-button type='text' @click='forupdatePrice(scope.taxval)' v-if="submitStatus == '0'">修改发票</el-button>
                            <el-button type='text' @click='forinsp(scope.taxval)' v-if="submitStatus == '0'">发票查验</el-button>
                            <el-button type='text' @click='deleteInvoice(scope.taxval)' v-if="submitStatus == '0'">删除发票</el-button>
                            <el-button type='text' @click='forinspMember(scope.taxval)' v-if="submitStatus == '0'">置为查验成功</el-button>
                        </div>
                    </template>
                </taxtable>
            </div>
            <div class='box-item'>
                <div class='titledetail'>其他票据明细头字段</div>
                <taxtable :headData='otherheadData' ref='otherref' :tableData='othertableData'>
                    <template v-slot:no='scope'>
                        {{ scope.index + 1 }}
                    </template>
                    <template v-slot:operate='scope'>
                        <div class='Centerupdown'>
                            <el-button type='text' @click='forupdatePrice(scope.taxval)' v-if="submitStatus == '0'">修改发票</el-button>
                            <el-button type='text' @click='forinsp(scope.taxval)' v-if="submitStatus == '0'">发票查验</el-button>
                            <el-button type='text' @click='deleteInvoice(scope.taxval)' v-if="submitStatus == '0'">删除发票</el-button>
                        </div>
                    </template>
                </taxtable>
            </div>
            <div class='box-item'>
                <div class='titledetail'>其他附件（影像）</div>
                <taxtable :headData='fileheadData' ref='attachref' :tableData='filetableData'>
                    <template v-slot:no='scope'>
                        {{ scope.index + 1 }}
                    </template>
                    <template v-slot:operate='scope'>
                        <div class='Centerupdown'>
                            <el-button type='text' @click='foraddprice(scope.taxval)' v-if="submitStatus == '0'">录入票据</el-button>
                            <el-button type='text' @click='deleteFile(scope.taxval)' v-if="submitStatus == '0'">删除附件</el-button>
                        </div>
                    </template>
                </taxtable>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import FeeSplit from './FeeSplit.vue';
import updatevatdiag from './updatevatdiag.vue';
import addvatdiag from './addvatdiag.vue';
import {
    deleteFeeInvoice,
    deleteFile,
    getFeeCollectionBatchInfo,
    inspInvoice,
    manualInspSuccess
} from '../../../../api/home';
import http from '../../../../../configHttp';

export default {
    components: {
        FeeSplit,
        updatevatdiag,
        addvatdiag
    },
    props: {
        FeeDetaildiag: {
            type: Boolean,
            default: false
        },
        feeCollectionId: {
            type: Number,
            default: 0
        }
    },
    watch: {
        FeeDetaildiag: function(indexVal, oldVal) {
            if (indexVal) {
                this.repairtable();
                this.getFeeCollectionBatchInfo(this.feeCollectionId);
            }
        }
    },
    data() {
        return {
            fileName: '',
            addvatdiag: false,
            updatevatdiag: false,
            mailBatchNo: '',
            batchNo: '',
            vattableData: [],
            invoiceId: 0,
            vatheadData: [
                {
                    title: 'NO.',
                    prop: 'no',
                    width: 100,
                    fixed: 'left',
                    custom: true
                },
                {
                    title: '公司代码',
                    prop: 'companyCode',
                    width: 200
                },
                {
                    title: '票据类型',
                    prop: 'invoiceType',
                    width: 100,
                    custom: true
                },
                {
                    title: '发票代码',
                    prop: 'invoiceCode',
                    width: 200
                },
                {
                    title: '发票号码',
                    prop: 'invoiceNumber',
                    width: 200
                },
                {
                    title: '开票日期',
                    prop: 'invoiceDate',
                    width: 200
                },
                {
                    title: '不含税金额',
                    prop: 'amount',
                    width: 150
                },
                {
                    title: '税额',
                    prop: 'tax',
                    width: 100
                },
                {
                    title: '税率',
                    prop: 'taxRate',
                    custom: true,
                    width: 100
                },
                {
                    title: '含税金额',
                    prop: 'totalAmount',
                    width: 100
                },
                {
                    title: '购方税号',
                    prop: 'buyerTaxNumber',
                    width: 200
                },
                {
                    title: '销方税号',
                    prop: 'supplierTaxNumber',
                    width: 200
                },
                {
                    title: '发票PO',
                    prop: 'poNumber',
                    width: 200
                },
                {
                    title: '查验结果',
                    prop: 'inspectionStatus',
                    custom: true,
                    width: 100
                },
                {
                    title: '操作',
                    prop: 'operate',
                    width: 400,
                    custom: true,
                    fixed: 'right'
                }
            ],
            otherheadData: [
                {
                    title: 'NO.',
                    prop: 'no',
                    width: 100,
                    fixed: 'left',
                    custom: true
                },
                {
                    title: '公司代码',
                    prop: 'companyCode',
                    width: 200
                },
                {
                    title: '发票号码',
                    prop: 'invoiceNumber',
                    width: 200
                },
                {
                    title: '销方名称',
                    prop: 'supplierName',
                    width: 200
                },
                {
                    title: '发票金额(含税)',
                    prop: 'totalAmount',
                    width: 100
                },
                {
                    title: '发票金额(不含税)',
                    prop: 'amount',
                    width: 100
                },
                {
                    title: '开票日期',
                    prop: 'invoiceDate',
                    width: 200
                },
                {
                    title: 'PO号',
                    prop: 'poNumber',
                    width: 200
                },
                {
                    title: '币种',
                    prop: 'currency',
                    width: 100
                },
                {
                    title: '购方名称',
                    prop: 'buyerName',
                    width: 200
                },
                {
                    title: '操作',
                    prop: 'operate',
                    width: 300,
                    custom: true,
                    fixed: 'right'
                }
            ],
            othertableData: [],
            fileheadData: [{
                title: 'NO.',
                prop: 'no',
                width: 100,
                fixed: 'left',
                custom: true
            },
                {
                    title: '文件名',
                    prop: 'fileName'
                },
                {
                    title: '操作',
                    prop: 'operate',
                    width: 200,
                    custom: true,
                    fixed: 'right'
                }
            ],
            filetableData: [],
            // 拆分批次
            Splitdiag: false,
            spilttableData: [],
            feeCollectionInfo: {},
            submitStatus: ''    //  提交主流程状态
        };
    },
    methods: {
        // 上传文件
        uploadFile() {
            let obj = {
                uploadurl: http.baseURL + 'fee/invoice/uploadFile',
                uploadtitle: '上传文件',
                params: { batchNo: this.batchNo }
            };
            this.$upload(obj).then(res => {
                if (res.success) {
                    this.$message.success('上传成功');
                    this.getFeeCollectionBatchInfo(this.feeCollectionId);
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        //拆分批次相关
        forSplit() {
            this.spilttableData.forEach(item => {
                item.groupNumber = 1;
            });
            this.Splitdiag = true;
        },
        closeSplitdiag() {
            this.Splitdiag = false;
            this.getFeeCollectionBatchInfo(this.feeCollectionId);
        },
        submitSplit(e) {
            console.log(e);
        },
        getFeeCollectionBatchInfo(id) {
            getFeeCollectionBatchInfo(id).then(res => {
                if (res.data.success) {
                    this.mailBatchNo = res.data.data.mailBatchNo;
                    this.batchNo = res.data.data.batchNo;
                    this.submitStatus = res.data.data.submitStatus;
                    this.vattableData = res.data.data.VAT;
                    this.othertableData = res.data.data.NVAT;
                    this.filetableData = res.data.data.file;
                    this.spilttableData = [];
                    this.vattableData.forEach(item => {
                        this.spilttableData.push(item);
                    });
                    this.othertableData.forEach(item => {
                        this.spilttableData.push(item);
                    });
                }
            });
        },
        // 增值税发票相关   
        deleteInvoice(row) {
            this.$showConfirm({
                message: '确认删除?'
            }).then(res => {
                let params = {
                    id: row.id,
                    batchNo: row.batchNo
                };
                deleteFeeInvoice(params).then(res => {
                    if (res.data.success) {
                        this.$message.success('删除成功');
                        this.getFeeCollectionBatchInfo(this.feeCollectionId);
                    } else {
                        this.$message.error(res.data.message);
                    }
                });
            });
        },
        deleteFile(row) {
            this.$showConfirm({
                message: '确认删除?'
            }).then(res => {
                deleteFile(row.fileUrl).then(res => {
                    if (res.data.success) {
                        this.$message.success('附件删除成功');
                        this.getFeeCollectionBatchInfo(this.feeCollectionId);
                    } else {
                        this.$message.error('删除附件失败:' + res.data.message);
                    }
                });
            });
        },
        //发票查验
        forinsp(row) {
            inspInvoice(row.id).then(res => {
                if (res.data.success) {
                    this.$message.success('提交查验成功');
                    this.getFeeCollectionBatchInfo(this.feeCollectionId);
                } else {
                    this.$message.error(res.data.message);
                }
            });
        },
        forinspMember(row) {
            this.$showConfirm({
                message: '确认手工置为查验成功?'
            }).then(res => {
                manualInspSuccess(row.id).then(res => {
                    if (res.data.success) {
                        this.$message.success('操作成功');
                        this.getFeeCollectionBatchInfo(this.feeCollectionId);
                    } else {
                        this.$message.error(res.data.message);
                    }
                });
            });
        },
        //录入票据
        foraddprice(row) {
            this.feeCollectionInfo = {
                fileName: row.fileName,
                fileUrl: row.fileUrl,
                batchNo: this.batchNo
            };
            this.addvatdiag = true;
        },
        //修改票据
        forupdatePrice(row) {
            this.updatevatdiag = true;
            this.invoiceId = row.id;
        },
        closeupdatevatdiag() {
            this.updatevatdiag = false;
            this.getFeeCollectionBatchInfo(this.feeCollectionId);
        },
        closeaddvatdiag() {
            this.addvatdiag = false;
            this.getFeeCollectionBatchInfo(this.feeCollectionId);
        },
        // 关闭弹框
        close() {
            this.$emit('closeFeeDetaildiag', false);
        },
        repairtable() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.vatref.dout();
                    this.$refs.otherref.dout();
                    this.$refs.attachref.dout();
                }, 200);
            });
        }
    }
};
</script>

<style scoped='scoped' lang='less'>
.box-item {
    margin-top: 20px;

    .titledetail:extend(.Centerhorizontally) {
        width: 100%;
        font-size: 18px;
        background-color: #87CEFA;
        padding: 10px 0px 10px 0px;
        font-weight: 600;
    }

    .title-content {
        font-size: 16px;
        margin-top: 20px;

        span {
            margin-right: 10px;
        }
    }
}
</style>
